import api from './apiClient'

export default {
 
  /**
   * 👤 Get daily revenue
   */
  async getDailyRevenue(params) {
    try {
      const res = await api.get(`/reports/daily-revenue`,{
        params
      })
      return res.data
    } catch (error) {
      const err = error.response
      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.errors || {}
      }
    }
  },

   /**
   * 👤 Get incoming invoices
   */
  async getIncomingInvoicesReport(params) {
    try {
      const res = await api.get(`/reports/incoming-invoices`,{
        params
      })
      return res.data
    } catch (error) {
      const err = error.response
      throw {
        status: err?.status,
        message: err?.data.message || 'Something went wrong',
        errors: err?.data.errors || {}
      }
    }
  },

  
   /**
   * 👤 Get cogs
   */
  async getCogsReport(params) {
    try {
      const res = await api.get(`/reports/cogs`,{
        params
      })
      return res.data
    } catch (error) {
      const err = error.response
      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.errors || {}
      }
    }
  },

}